import { AnimationBuilder } from '@angular/animations';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { DestroySubscriptionsService } from '@libs/src/destroy-subscription/destroy-subscription.service';

import { shake } from '@libs/src/animations/animations';

@Directive({
  providers: [DestroySubscriptionsService],
  selector: 'button[appButtonShakeTrigger]',
})
export class ButtonShakeTriggerDirective implements OnInit {
  @Input('appButtonShakeTrigger') trigger$: Observable<void>;

  constructor(
    private readonly builder: AnimationBuilder,
    private readonly destroy$: DestroySubscriptionsService,
    private readonly element: ElementRef,
  ) {}

  ngOnInit() {
    this.trigger$
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          const factory = this.builder.build(shake);
          const player = factory.create(this.element.nativeElement);
          player.play();
          player.onDone(() => player.destroy());
        }),
      )
      .subscribe();
  }
}
